// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader-module__wrapper","bar":"Loader-module__bar","to100AndBack":"Loader-module__to100AndBack"};